import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder } from '@angular/forms';
import { AppoggioService } from 'src/app/_servizi/appoggio.service';
import { CarrelloViniService } from 'src/app/_servizi/carrelloVini.service';
import { MessageServiceService } from 'src/app/_servizi/message-service.service';

@Component({
  selector: 'app-last-step-buonocantina',
  templateUrl: './last-step-buonocantina.component.html',
  styleUrls: ['./last-step-buonocantina.component.css']
})
export class LastStepBuonocantinaComponent implements OnInit, OnChanges {

  get colori() {
    return this.appoggioService.getColoriIframe();
  }

  get totale() {

    const przVisita = parseFloat(this.tipovisita.maxPrz);

    let przOk = 0;
    if (przVisita > 0) {
      przOk = przVisita;
    } else {
      przOk = parseFloat(this.tipovisita.costoDefault);
    }

    return przOk * this.adulti;
  }

  @Input() tipovisita: any;
  @Input() codiceForm: any;
  @Input() codiceFormMaster: any;

  @Input() linguaCorrente: any;

  adulti = 1;
  form: FormGroup;
  messaggioFormControl = new FormControl('');

  constructor(
    private fb: UntypedFormBuilder,
    private appoggioService: AppoggioService,
    private carrelloService: CarrelloViniService,
    private messageService: MessageServiceService
  ) {
    this.form = this.fb.group({
      messaggio: this.messaggioFormControl
    });
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.adulti = parseInt(this.tipovisita.defaultMin, 10);
  }

  adultiMeno() {
    const multipli = parseInt(this.tipovisita.defaultMultipli, 10);
    const min = parseInt(this.tipovisita.defaultMin, 10);

    if (this.adulti - multipli >= min) {
      this.adulti -= multipli;
    }
  }

  adultiPiu() {
    const multipli = parseInt(this.tipovisita.defaultMultipli, 10);
    const max = parseInt(this.tipovisita.defaultMax, 10);

    if (this.adulti + multipli <= max) {
      this.adulti += multipli;
    }
  }

  continua() {
    const valori = {
      idClientiMaster: this.tipovisita.idCantina,
      codiceFormMaster: this.codiceFormMaster,
      idCliente: null,
      idTipoVisita: this.tipovisita.id,
      durata: this.tipovisita.duratagg,
      tiporegala: this.tipovisita.tiporegala,
      fineregala: this.tipovisita.fineregala,
      npersone: this.adulti,
      totale: this.totale,
      nominativo: null,
      nome: null,
      email: null,
      messaggio: this.form.value.messaggio,
      dataRegaloAttiva: false,
      dataRegaloInvio: null,
      pacchetti: null
    };


    this.carrelloService.addCarrello('carrelloBuonoCantina', valori)
      .subscribe(result => {
        if (result['risultato'] === true) {
          this.messageService.sendClickMessage(null, null, this.linguaCorrente, 2, this.messageService.getIdCookie());
        } else {
        }
      });
  }
}